import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

export default function UsersPage() {
  const ref = useRefData();

  const columns = [
    {
      key: "code",
      label: "EMP ID",
      render: (u) => (
        <Link to={`/users/${u.id}`} className="font-mono text-xs text-sky-400 hover:underline" data-testid={`users-code-${u.id}`}>
          {u.code}
        </Link>
      ),
    },
    {
      key: "name",
      label: "Name",
      render: (u) => (
        <Link to={`/users/${u.id}`} className="text-white hover:text-sky-300 transition-colors" data-testid={`users-name-${u.id}`}>
          {u.name}
        </Link>
      ),
    },
    { key: "email", label: "Email" },
    { key: "role", label: "Role", render: (u) => <span className="text-zinc-400 text-xs capitalize">{(u.role || "team_associate").replace(/_/g," ")}</span> },
    { key: "contact_number", label: "Contact" },
    { key: "extension_number", label: "Ext" },
  ];

  const fields = [
    { key: "code", label: "EMP ID", required: true, disabledOnEdit: true, placeholder: "e.g., EMP1234 (unique, cannot be changed later)" },
    { key: "name", label: "Full Name", required: true },
    { key: "email", label: "Email", type: "email", required: true },
    { key: "role", label: "Role", type: "select", options: ["team_associate", "team_lead", "admin"] },
    { key: "contact_number", label: "Contact Number" },
    { key: "extension_number", label: "Extension" },
    { key: "wallet_number", label: "Wallet Number" },
  ];

  const initial = { code: "", name: "", email: "", role: "team_associate", contact_number: "", extension_number: "", wallet_number: "" };

  return (
    <EntityPage
      title="Users"
      subtitle="People with access to the console."
      testidPrefix="users"
      endpoint="/users"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
